import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const RecurringInput = ({name, label, onChange, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: 'calendar_recurring_none',
    },
    {
      value: 2,
      label: 'calendar_recurring_daily',
    },
    {
      value: 3,
      label: 'calendar_recurring_weekly',
    },
    {
      value: 4,
      label: 'calendar_recurring_monthly_by_date',
    },
    {
      value: 5,
      label: 'calendar_recurring_monthly_by_day',
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={[
            {required: true, message: t('feedback_validation_required')},
          ]}
          {...props}
        >
          <Select disabled={disabled} onChange={onChange}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default RecurringInput;
